export const ROUTES = {
  LOGIN: "/login",
  LOGIN_CONFIRM: "/login/confirm",
  LOGIN_RESET: "/login/reset",
  LOGIN_RESET_CONFIRM: "/login/reset-confirm",
  LOGIN_FIRST_CONNECTION: "/login/first-connection",
  LOGIN_CAMELEON: "/login-cameleon",

  PERIMETER_CUSTOMERS: "/search",
  PERIMETER_CONTRACTS: "/search/regroupement",
  PERIMETER_CONTRACTS_BY_CUSTOMER: "/search/regroupement/:customerId",
  PERIMETER_SITES: "/search/sites",
  PERIMETER_SITES_BY_CONTRACT: "/search/sites/:customerId/:contractId",
  PERIMETER_SITE: "/search/site/:customerId/:contractId/:siteId/:energy",

  DASHBOARD: "/",
  SETTINGS: "/settings",
  DOCUMENTS: "/documents",
  SHIELD: "/search/regroupement/:customerId/shield",
  FRESHDESK_TICKETS: "/tickets",

  ACCESS_MANAGER: "/access-manager",
  ACCESS_MANAGER_CREATE: "/access-manager/create",
  ACCESS_MANAGER_USER: "/access-manager/:userId",
} as const;
